export default function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`logo-mark ${className}`}>
      <div className="logo-globe-wrap" aria-hidden="true">
        <div className="logo-globe-shadow"></div>
        <div className="logo-ring"></div>
        <div className="logo-ring-inner"></div>
        <div className="logo-globe"></div>
        <div className="logo-globe-highlight"></div>
      </div>
    </div>
  );
}